<div class="page-top__dropdown-profile profile-top dropdown-menu dropdown-menu-right"
     role="menu"
     aria-labelledby="button-profile"
     *dropdownMenu>
  <span class="dropdown-item profile-top__item">{{ storeService.user?.firstName }} {{ storeService.user?.secondName }}</span>

<!--  <div class="dropdown-divider"></div>-->
<!--  <a class="profile-top__menu-select"-->
<!--     *ngFor="let item of collaborators"-->
<!--     [class.active]="item.active">-->
<!--    <span class="profile-top__menu-name text-truncate" [class.font-weight-bold]="item.active">{{ item.name }}</span>-->
<!--  </a>-->
<!--  <div class="dropdown-divider"></div>-->

<!--  <a class="dropdown-item profile-top__item" href="#">-->
<!--    <icon-cog class="profile-top__icon"></icon-cog>-->
<!--    <span class="text-body ml-3">Help</span>-->
<!--  </a>-->
  <button class="dropdown-item profile-top__item"
          (click)="logOut()">
    <icon-sign-out class="profile-top__icon"></icon-sign-out>
    <span class="text-body ml-3">Logout</span>
  </button>
</div>
